import React, { useEffect, useState } from "react";
import { EyeOutlined, PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, ExpandAltOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Table, Button, Card, Form, FormInstance, Select, Input, Tabs, DatePicker, Space, Spin, } from 'antd';
import dayjs from 'dayjs';
import { AlignType } from 'rc-table/lib/interface';

import { SelecionarArquivo } from "../../../components/Documentos/SelecionarArquivo";
import { apiAuxiliar, obterCondicaosValidade } from "../../../services/apiAuxiliar";

import { errorMessage, mostrarInfo, successMessage } from "../../../utils/messages";
import { IMandatoHabilitacao, IDocumentoDirigenteHabilitacaoAnalise, IDocumentoDirigenteHabilitacaoEfpc, IEnumCondicaoValidade } from "../Componentes/InterfaceMandato";
import { ICtrlDoc } from "../../../Interfaces/DadosPrevicInterfaces";
import { IChaves } from "../../../Interfaces/Interfaces";

import { onlyNumbers, disabledDate, hasText } from "../../../utils/utilsFunctions";
import { getDocPdf } from "../../../services/apiDocumentos";
import { maskNumeroProcesso } from "../../../utils/maskFunctions";

import DirigenteHabilitacaoDocumentoAnalise from "./DirigenteHabilitacaoDocumentoAnalise";
import DirigenteHabilitacaoDocumentoEntidade from "./DirigenteHabilitacaoDocumentoEntidade";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";

interface IProps {
  form: FormInstance<any>;
  mandatoHabilitacao: IMandatoHabilitacao[];
  setMandatoHabilitacao: React.Dispatch<React.SetStateAction<IMandatoHabilitacao[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
  tipoMandato?: number; // 1 : Diretor / 2 : Conselheiro
}

const { Option } = Select;
const { TextArea } = Input;

const DirigenteHabilitacao = ({ form, mandatoHabilitacao, setMandatoHabilitacao, manter, tipoMandato }: IProps) => {
  const [dirigenteHabilitacaoDocumentoAnalise, setDirigenteHabilitacaoDocumentoAnalise] = useState<IDocumentoDirigenteHabilitacaoAnalise[]>([]);
  const [dirigenteHabilitacaoDocumentoEntidade, setDirigenteHabilitacaoDocumentoEntidade] = useState<IDocumentoDirigenteHabilitacaoEfpc[]>([]);

  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo detalhe /  3 : Modal em modo edição
  const [exibirModalHab, setExibirModalHab] = useState(false);
  const [exibirDirigenteHabilitacaoCadastrada, setExibirDirigenteHabilitacaoCadastrada] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");
  const [dadosValidados, setDadosValidados] = useState(false);

  const [chave, setChave] = useState<number|undefined>();
  const [fileList, setFileList] = useState<IChaves>();


  useEffect(() => {
    liberarVisualizacao();

    if (ctrlDocEfpc.length === 0) getCtrlDocEfpc();
    if (ctrlDocAnalise.length === 0) getCtrlDocAnalise();
    if (condicaoValidade.length === 0) getCondicaoValidade();
  }, []);

  function liberarVisualizacao(){
    if (manter === 2 || manter === 9) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    } else {
      //Tem que ter permissão de adicionar ou alterar habilitação
      if (hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO])){
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirElementoAcaoAlteracao("none");
      }
    }
  }

  useEffect(() => {
    if (mandatoHabilitacao.length === 0) {
      setExibirDirigenteHabilitacaoCadastrada("none")
    } else {
      setExibirDirigenteHabilitacaoCadastrada("inline")
    }
  }, [mandatoHabilitacao]);

  useEffect(() => {
    liberarVisualizacao();
  }, [manter]);

  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // CONFIGURA MODAL PARA ABRIR
    } else if (estadoModal === 2) { // EXIBIR DETALHES
      controleDaGrid("detalhar"); // CONFIGURA MODAL PARA ABRIR
    }
  }, [estadoModal]);

  useEffect(() => {
    if (chave) {
      setFileList(
        {
          idDocumento: chave,
          touched: true,
        },
      );

      form.setFieldsValue({
        "idDocumento": chave,
        "chave": chave,
      })
      if (Number(form?.getFieldValue("idPessoaFisicaCertificado")) > 0 && Number(form?.getFieldValue("idDocumento")) === 0) {
        successMessage("O documento será substituído");
      }
    }
  }, [chave]);


  const controleDaGrid = (botao: string) => {
    if (!hasText(form.getFieldValue("matriculaEfpc"))) {
      mostrarInfo("Não é possível incluir nova habilitação", "Entidade não informada");
    } else if (!hasText(form.getFieldValue("nmCargo")) && tipoMandato === 1) {
      mostrarInfo("Não é possível incluir nova habilitação", "Nome do cargo não informado");
    } else if (!hasText(form.getFieldValue("dtInicioMandato"))) {
      mostrarInfo("Não é possível incluir nova habilitação", "Datas de mandato não informadas");
    } else {
      if (botao === "cancelar") {
        setExibirModalHab(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalHab(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "fechar") {
        setExibirModalHab(false);
        setExibirElementoAcaoAlteracao("none");
      } else {
        setExibirModalHab(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }
  };

  const validarDirigenteHabilitacao = () => {
    if (!fileList || !fileList.idDocumento) {
      errorMessage("Selecione um arquivo para 'upload'.");
    } else if (dirigenteHabilitacaoDocumentoEntidade.length === 0) {
      mostrarInfo("Documentos", "Nenhum documento de entidade foi anexado.");
    } else if (dirigenteHabilitacaoDocumentoAnalise.length === 0) {
      mostrarInfo("Documentos", "Nenhum documento de análise foi anexado.");
    } else {
      form
        .validateFields([
          "idHabilitacao",
          "nuProcesso",
          "teNuHabilitacao",
          "dtEmissao",
          "dtValidade",
          "csCondicaoValidade",
          "tpCondicaoValidade",
          "teObservacao",
        ])
        .then(() => {
          setDadosValidados(true);
          controleDaGrid("incluir");
          setDadosDirigenteHabilitacao();
        })
        .catch((error) => {
          if (!dadosValidados) {
            errorMessage("Campo obrigatório não preechido ou não validado");
          } else {
            errorMessage(error.message);
          }
          setDadosValidados(false);
        });
    }
  };

  const setDadosDirigenteHabilitacao = () => {
    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setMandatoHabilitacao(pre => {
        return pre.map(consHab => {
          if (consHab.emEdicao) {
            return ({
              idHabilitacao: estadoModal === 3 ? Number(form?.getFieldValue("idHabilitacao")) : -1,
              nuProcesso: onlyNumbers(form?.getFieldValue("nuProcesso")),
              teNuHabilitacao: form?.getFieldValue("teNuHabilitacao")?.toUpperCase(),
              dtEmissao: form?.getFieldValue("dtEmissao") ? dayjs(form?.getFieldValue("dtEmissao")).format("YYYY-MM-DD") : "",
              dtValidade: form?.getFieldValue("dtValidade") ? dayjs(form?.getFieldValue("dtValidade")).format("YYYY-MM-DD") : "",
              csCondicaoValidade: Number(form?.getFieldValue("csCondicaoValidade")),
              tpCondicaoValidade: form?.getFieldValue("tpCondicaoValidade")?.toUpperCase(),
              teObservacao: form?.getFieldValue("teObservacao")?.toUpperCase(),
              idDocumento: form?.getFieldValue("idDocumento") ? Number(form?.getFieldValue("idDocumento")) : 0,
              documentoChave: fileList,
              habilitacaoDocsAnalise: dirigenteHabilitacaoDocumentoAnalise.map((e: IDocumentoDirigenteHabilitacaoAnalise) => {
                return {
                  ...e
                };
              }),
              habilitacaoDocsEfpc: dirigenteHabilitacaoDocumentoEntidade.map((e: IDocumentoDirigenteHabilitacaoEfpc) => {
                return {
                  ...e
                };
              }),
              statusReg: 1,
              touched: true,
              emEdicao: false,
            })
          } else {
            return consHab
          }
        })
      });
    } else {
      setMandatoHabilitacao([
        ...mandatoHabilitacao,
        {
          idHabilitacao: estadoModal === 3 ? Number(form?.getFieldValue("idHabilitacao")) : -1,
          nuProcesso: onlyNumbers(form?.getFieldValue("nuProcesso")),
          teNuHabilitacao: form?.getFieldValue("teNuHabilitacao")?.toUpperCase(),
          dtEmissao: form?.getFieldValue("dtEmissao") ? dayjs(form?.getFieldValue("dtEmissao")).format("YYYY-MM-DD") : "",
          dtValidade: form?.getFieldValue("dtValidade") ? dayjs(form?.getFieldValue("dtValidade")).format("YYYY-MM-DD") : "",
          csCondicaoValidade: Number(form?.getFieldValue("csCondicaoValidade")),
          tpCondicaoValidade: form?.getFieldValue("tpCondicaoValidade")?.toUpperCase(),
          teObservacao: form?.getFieldValue("teObservacao")?.toUpperCase(),
          idDocumento: chave,
          documentoChave: fileList,
          habilitacaoDocsAnalise: dirigenteHabilitacaoDocumentoAnalise.map((e: IDocumentoDirigenteHabilitacaoAnalise) => {
            return {
              ...e
            };
          }),
          habilitacaoDocsEfpc: dirigenteHabilitacaoDocumentoEntidade.map((e: IDocumentoDirigenteHabilitacaoEfpc) => {
            return {
              ...e
            };
          }),
          statusReg: 1,
          emEdicao: false,
          touched: true,
        },
      ]);

    }
    limpaDados();
    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  const limpaDados = () => {
    form.resetFields([
      "idHabilitacao",
      "nuProcesso",
      "teNuHabilitacao",
      "dtEmissao",
      "dtValidade",
      "csCondicaoValidade",
      "tpCondicaoValidade",
      "teObservacao",
    ]);
    setDirigenteHabilitacaoDocumentoAnalise([]);
    setDirigenteHabilitacaoDocumentoEntidade([]);
    setChave(undefined);
    setFileList(undefined);
  }

  const setFieldsDetalharEditar = (IMandatoHabilitacao: IMandatoHabilitacao) => {
    form.setFieldsValue({
      "idHabilitacao": IMandatoHabilitacao.idHabilitacao,
      "nuProcesso": IMandatoHabilitacao.nuProcesso ? maskNumeroProcesso(IMandatoHabilitacao.nuProcesso) : undefined,
      "dtEmissao": IMandatoHabilitacao.dtEmissao ? dayjs(IMandatoHabilitacao.dtEmissao) : undefined,
      "teNuHabilitacao": IMandatoHabilitacao.teNuHabilitacao,
      "dtValidade": IMandatoHabilitacao.dtValidade ? dayjs(IMandatoHabilitacao.dtValidade) : undefined,
      "csCondicaoValidade": IMandatoHabilitacao.csCondicaoValidade,
      "tpCondicaoValidade": IMandatoHabilitacao.tpCondicaoValidade,
      "teObservacao": IMandatoHabilitacao.teObservacao,
      "chave": IMandatoHabilitacao.idDocumento,
      "idDocumento": IMandatoHabilitacao.idDocumento
    });
    setChave(IMandatoHabilitacao.idDocumento);


    if (IMandatoHabilitacao.habilitacaoDocsAnalise?.map) {
      let docs = IMandatoHabilitacao.habilitacaoDocsAnalise.map((doc, i) => {
        return {
          idHabilitacaoDocAnalise: doc.idHabilitacaoDocAnalise,
          nuDocumento: doc.nuDocumento,
          dtDocumento: doc.dtDocumento,
          idCtrlDocTpDoc: doc.idCtrlDocTpDoc,
          nmTpDoc: doc.nmTpDoc?.toUpperCase(),
          chave: doc.idDocumento,
          documentoChave: doc.documentoChave,
          idDocumento: doc.idDocumento,
          documentoArquivo: doc.documentoArquivo,
          ctrlDocTipoDocumento: doc.ctrlDocTipoDocumento,
          statusReg: doc.statusReg,
          touched: false,
        }
      });
      setDirigenteHabilitacaoDocumentoAnalise(docs);
    }

    if (IMandatoHabilitacao.habilitacaoDocsEfpc?.map) {
      let docs = IMandatoHabilitacao.habilitacaoDocsEfpc.map((doc, i) => {
        return {
          idHabilitacaoDocEfpc: doc.idHabilitacaoDocEfpc,
          nuDocumento: doc.nuDocumento,
          dtDocumento: doc.dtDocumento,
          idCtrlDocTpDoc: doc.idCtrlDocTpDoc,
          nmTpDoc: doc.nmTpDoc?.toUpperCase(),
          chave: doc.idDocumento,
          documentoChave: doc.documentoChave,
          idDocumento: doc.idDocumento,
          documentoArquivo: doc.documentoArquivo,
          ctrlDocTipoDocumento: doc.ctrlDocTipoDocumento,
          statusReg: doc.statusReg,
          touched: false,
        }
      });
      setDirigenteHabilitacaoDocumentoEntidade(docs);
    }

  }

  const columns = [
    {
      // width: 200,
      key: "1",
      title: "Número do Processo",
      dataIndex: "",
      render: (IMandatoHabilitacao: IMandatoHabilitacao) => <>{IMandatoHabilitacao.nuProcesso ? maskNumeroProcesso(IMandatoHabilitacao.nuProcesso) : ""}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Número do Atestado",
      dataIndex: "",
      render: (IMandatoHabilitacao: IMandatoHabilitacao) => <>{IMandatoHabilitacao.teNuHabilitacao ? IMandatoHabilitacao.teNuHabilitacao : ""}</>,
    },
    {
      // width: 200,
      key: "3",
      title: "Data da Emissão",
      dataIndex: "",
      render: (IMandatoHabilitacao: IMandatoHabilitacao) => <> {IMandatoHabilitacao.dtEmissao ? dayjs(IMandatoHabilitacao.dtEmissao).format("DD/MM/YYYY") : ""}</>,
    },
    {
      // width: 200,
      key: "4",
      title: "Data da Validade",
      dataIndex: "",
      render: (IMandatoHabilitacao: IMandatoHabilitacao) => <> {IMandatoHabilitacao.dtValidade ? dayjs(IMandatoHabilitacao.dtValidade).format("DD/MM/YYYY") : ""}</>,
    },
    {
      key: "111", // PARA ARQUIVOS JÁ SALVOS NA TABELA DE DOCUMENTOS ARQUIVOS
      title: "Arquivo",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IDoc: IMandatoHabilitacao) => (
        <Button
          id="arquivo"
          shape="round"
          icon={<EyeOutlined />}
          htmlType="button"
          onClick={() => {
            getDocPdf(IDoc.idDocumento ? IDoc.idDocumento : (IDoc.documentoArquivo?.id!));
          }}
        />
      ),
    },
    {
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IMandatoHabilitacao: IMandatoHabilitacao) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 2 || manter === 9 ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(2); // SET O MODO DETALHAR
                  setFieldsDetalharEditar(IMandatoHabilitacao);
                }}
              />
            </div>

            <div style={{ display: IMandatoHabilitacao.statusReg !== undefined && IMandatoHabilitacao.statusReg !== 1 ? "none" : (manter === 1 ? "inline" : exibirElementoAcaoAlteracao) }}>
              <EditOutlined
                title={"Editar"}
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(3); // SET O MODO EDIÇÃO
                  setFieldsDetalharEditar(IMandatoHabilitacao);
                  // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                  mandatoHabilitacao.forEach(hab => {
                    if (hab === IMandatoHabilitacao) {
                      hab.statusReg = IMandatoHabilitacao?.statusReg !== undefined ? IMandatoHabilitacao?.statusReg : 1;
                      hab.touched = true;
                      hab.emEdicao = estadoModal === 3 ? true : false;
                    } else {
                      hab.emEdicao = false;
                    }
                  })
                  IMandatoHabilitacao.emEdicao = true;
                }}
              />

              <DeleteOutlined
                title="Exluir Habilitação não salva na base"
                style={{ color: "red", display: (IMandatoHabilitacao?.idHabilitacao && IMandatoHabilitacao?.idHabilitacao < 0) && hasPermissao([Papel.DILIC_MASTER]) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setMandatoHabilitacao(mandatoHabilitacao.filter((hab) => hab !== IMandatoHabilitacao));
                }}
              />
            </div>

            <div style={{ display: (IMandatoHabilitacao?.idHabilitacao && IMandatoHabilitacao?.idHabilitacao > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <DeleteOutlined
                  title="Excluir Habilitação já salva na base"
                  style={{ color: "red", display: (IMandatoHabilitacao?.statusReg === 1 || IMandatoHabilitacao?.statusReg === undefined) ? "inline" : "none" }}
                  onClick={() => {
                    IMandatoHabilitacao.touched = true; // MARCA O REGISTRO ALTERADO.
                    IMandatoHabilitacao.statusReg = (IMandatoHabilitacao.statusReg === 1 ? 2 : 1);
                    setMandatoHabilitacao(pre => {
                      return pre.map(manda => {
                        if (manda.idHabilitacao === IMandatoHabilitacao.idHabilitacao) {
                          return IMandatoHabilitacao;
                        } else {
                          return manda;
                        }
                      });
                    });
                  }}
                />
              </>
            </div>
          </Space>
      ),
    },

  ];


  const [csCondicaoValidade, setCsCondicaoValidade] = useState(0);
  const [datePickerDtValidadeValue, setDatePickerDtValidadeValue] = useState<string>();

  const handlerCondicaoValidade = async (value: any) => {
    form.setFieldsValue({
      "tpCondicaoValidade": value.children,
      "csCondicaoValidade": value.key,
    });
    setCsCondicaoValidade(Number(value.key));
  };

  const handlerDtEmissao = async () => {
    handlerDtValidade(form?.getFieldValue("csCondicaoValidade"));
  };

  const handlerDtValidade = async (key: any) => {
    if (key === 1) { // Validade do certificado
      setDatePickerDtValidadeValue(undefined);
    } else if (key === 2) { // FIM DO MANDATO
      if (form.getFieldValue("dtFimMandato") && form.getFieldValue("dtFimMandato") !== "") {
        setDatePickerDtValidadeValue(form.getFieldValue("dtFimMandato"));
      } else {
        if (form?.getFieldValue("dtEmissao") && form?.getFieldValue("dtEmissao") !== "") {
          const newDateValue = (dayjs(form.getFieldValue("dtEmissao"), 'YYYY-MM-DD')).add(4, "year")
          setDatePickerDtValidadeValue(newDateValue.format("YYYY-MM-DD"))
        } else {
          setDatePickerDtValidadeValue(undefined);
        }
      }
    } else if (key === 3) { // PRAZO DE 4 ANOS
      if (form?.getFieldValue("dtEmissao") && form?.getFieldValue("dtEmissao") !== "") {
        const newDateValue = (dayjs(form.getFieldValue("dtEmissao"), 'YYYY-MM-DD')).add(4, 'year')
        setDatePickerDtValidadeValue(newDateValue.format("YYYY-MM-DD"))
      } else {
        setDatePickerDtValidadeValue(undefined);
      }
    } else {
      setDatePickerDtValidadeValue(undefined);
    }
  };

  useEffect(() => {
    if (datePickerDtValidadeValue === undefined){
      form.setFieldsValue({
        "dtValidade": ''
      })
      setDatePickerDtValidadeValue("");
    } else if (datePickerDtValidadeValue !== "") {
      form.setFieldsValue({
        "dtValidade": dayjs(datePickerDtValidadeValue)
      })
      setDatePickerDtValidadeValue("");
    }
  }, [datePickerDtValidadeValue]);

  useEffect(() => {
    if (csCondicaoValidade) {
      handlerDtValidade(csCondicaoValidade);
    }
  }, [csCondicaoValidade]);

  const handleCancel = () => {
    setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO. MODO PADRÃO
    estadoModal === 2 ? controleDaGrid("fechar") : controleDaGrid("cancelar");
    // controleDaGrid("cancelar");
    form.resetFields([
      "idHabilitacao",
      "nuProcesso",
      "teNuHabilitacao",
      "dtEmissao",
      "dtValidade",
      "csCondicaoValidade",
      "tpCondicaoValidade",
      "teObservacao",
    ]);
    setDirigenteHabilitacaoDocumentoAnalise([]);
    setDirigenteHabilitacaoDocumentoEntidade([]);
  };

  const [condicaoValidade, setCondicaoValidade] = useState<IEnumCondicaoValidade[]>([]);
  const getCondicaoValidade = async () => {
    const { data } = await obterCondicaosValidade();
    setCondicaoValidade(data);
  };

  const [ctrlDocEfpc, setCtrlDocEfpc] = useState<ICtrlDoc[]>([]);
  const getCtrlDocEfpc = async () => {
    let lQuery = "";
    if (manter === 1) {
      // CADASTRO
      lQuery = `/auxiliar/tabelas/ctrldoc-tipo-doc/propriedades?propriedades=entidade,previc,cadastrar,conselheiro-deliberativo,conselheiro-fiscal,habilitacao,doc-efpc`;

    } else {
      // ALTERAÇÃO
      lQuery = `/auxiliar/tabelas/ctrldoc-tipo-doc/propriedades?propriedades=entidade,previc,manter,conselheiro-deliberativo,conselheiro-fiscal,habilitacao,doc-efpc`;
    }

    const { data } = await apiAuxiliar.get(lQuery);
    setCtrlDocEfpc(data.content);
  };

  const [ctrlDocAnalise, setCtrlDocAnalise] = useState<ICtrlDoc[]>([]);
  const getCtrlDocAnalise = async () => {
    let lQuery;
    if (manter === 1) {
      // CADASTRO
      lQuery = `/auxiliar/tabelas/ctrldoc-tipo-doc/propriedades?propriedades=previc,cadastrar,conselheiro-deliberativo,conselheiro-fiscal,habilitacao,doc-analise`;
    } else {
      // ALTERAÇÃO
      lQuery = `/auxiliar/tabelas/ctrldoc-tipo-doc/propriedades?propriedades=previc,manter,conselheiro-deliberativo,conselheiro-fiscal,habilitacao,doc-analise`;
    }
    const { data } = await apiAuxiliar.get(lQuery);
    setCtrlDocAnalise(data.content);
  };

  function calculateAge(date1: any, date2: any) { // birthday is a date
    const ageDifMs = date1 - date2;
    const ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getFullYear() - 1970);
  }

  // State to store the value of the DatePicker
  return (
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirDirigenteHabilitacao"
        type="primary"
        shape="round"
        onClick={() => {
          limpaDados();
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("incluirDirigenteHabilitacao");
        }}
        icon={<PlusOutlined />}
      >
        Incluir Habilitação
      </Button>

      <>
        <Modal title="Incluir Habilitação" open={exibirModalHab}
          style={{ top: 20 }}
          destroyOnHidden={true}
          width={700}
          closable={false}
          footer={[
            <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
              {estadoModal === 2 ? "Fechar" : "Cancelar"}
            </Button>,
            <Button icon={<CheckOutlined />} disabled={chave ? false : true} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
              key="ok" type="primary" onClick={validarDirigenteHabilitacao}>
              {estadoModal === 3 ? "Alterar" : "Incluir"}
            </Button>,
          ]}
        >
          <Spin spinning={loading} tip={tipLoading}>
            <>

              <Card title="Dados da Habilitação">
                <Row>
                  <Col xs={24} sm={8}>
                    <Form.Item label='Número do Processo'
                      name='nuProcesso'
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "Digite um número válido",
                        },
                      ]}
                    >
                      <Input
                        disabled={manter === 2 || manter === 9 ? true : false}
                        onChange={(e) => {
                          form.setFieldsValue({
                            nuProcesso: maskNumeroProcesso(e.target.value)
                          })
                        }}
                        maxLength={20}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={10}>
                    <Form.Item label='Número do Atestado'
                      // labelCol={{ span: 12 }}
                      labelAlign="left"
                      name='teNuHabilitacao'
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "O número do atestado é obrigatório",
                        },
                      ]}
                    >
                      <Input
                        disabled={manter === 2 || manter === 9 ? true : false}
                        maxLength={20}
                      />
                    </Form.Item>
                  </Col>

                </Row>

                <Row>
                  <Col xs={24} sm={6}>
                    <Form.Item label="Data de Emissão"
                      name="dtEmissao"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "O campo data de emissão é obrigatório",
                        },
                        // {
                        //   validator: async (_, startDatetime) => {
                        //     let dtInicioMandato = form.getFieldValue("dtInicioMandato");
                        //     if (dtInicioMandato && startDatetime) {
                        //       startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                        //       dtInicioMandato = dayjs(dtInicioMandato).format("YYYY-MM-DD")
                        //       if (startDatetime < dtInicioMandato) {
                        //         return Promise.reject(
                        //           "Data de emissão da habilitação deve ser maior ou igual à data inicial do mandato"
                        //         );
                        //       }
                        //     }
                        //   },
                        // },
                        {
                          validator: async (_, startDatetime) => {
                            let dtInicioExercicio = form.getFieldValue("dtInicioExercicio");
                            if (dtInicioExercicio && startDatetime) {
                              startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                              dtInicioExercicio = dayjs(dtInicioExercicio).format("YYYY-MM-DD")
                              if (startDatetime > dtInicioExercicio) {
                                return Promise.reject(
                                  "'Início do Exercício' não pode ser anterior à 'Data da Emissão' do atestado de habilitação"
                                );
                              }
                            }
                          },
                        },
                      ]}
                    >
                      <DatePicker
                        onChange={handlerDtEmissao}
                        format={"DD/MM/YYYY"}
                        style={{ width: "100%" }}
                        disabledDate={disabledDate}
                        placeholder="Selecionar Data"
                        disabled={estadoModal === 2}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Form.Item label="Condição de Validade do Atestado"
                      // labelCol={{ span: 6 }}
                      name="tpCondicaoValidade"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "O campo tipo de prazo é obrigatório",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        filterOption
                        optionFilterProp='children'
                        placeholder='Condição de Validade'
                        onChange={(_, index) => {
                          handlerCondicaoValidade(index);
                        }}
                        disabled={estadoModal === 2}
                      >
                        {condicaoValidade?.map((e: IEnumCondicaoValidade) => (
                          <Option key={e.valor} value={e.valor}>
                            {e.descricao}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={6}>
                    <Form.Item label="Data de Validade"
                      name="dtValidade"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "O campo data de validade é obrigatório",
                        },
                        {
                          validator: async (_, endDatetime) => {
                            let startDatetime = form.getFieldValue("dtEmissao");
                            if (startDatetime && endDatetime) {
                              endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                              startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                              if (endDatetime <= startDatetime) {
                                return Promise.reject(
                                  "Data de validade deve ser maior do que a data de emissão"
                                );
                              }
                            }
                          },
                        },
                        {
                          validator: async (_, endDatetime) => {
                            let dtFimMandato = form.getFieldValue("dtFimMandato");
                            if (dtFimMandato && endDatetime) {
                              endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                              dtFimMandato = dayjs(dtFimMandato).format("YYYY-MM-DD")
                              if (endDatetime > dtFimMandato) {
                                return Promise.reject(
                                  "Data de validade da habilitação deve ser menor ou igual à data final de mandato"
                                );
                              }
                            }
                          },
                        },
                        {
                          validator: async (_, endDatetime) => {
                            let dtEmissao = form.getFieldValue("dtEmissao");
                            if (dtEmissao && endDatetime) {
                              endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                              dtEmissao = dayjs(dtEmissao).format("YYYY-MM-DD")

                              if (calculateAge(new Date(endDatetime), new Date(dtEmissao)) >= 4) {
                                return Promise.reject(
                                  "A habilitação não pode durar mais do que 4 anos."
                                );
                              }
                            }
                          },
                        },
                      ]}
                    >
                      <DatePicker
                        disabled={estadoModal === 2 || (csCondicaoValidade !== 1 && csCondicaoValidade !== 9)}
                        format={"DD/MM/YYYY"}
                        style={{ width: "100%" }}
                        placeholder="Selecionar Data"
                      />
                    </Form.Item>
                  </Col>
                </Row>


              </Card>

              <Card title="Atestado de Habilitação" variant="borderless" style={{ width: "100%" }}>
                <>
                  <Row justify="space-between">
                    <Col xs={24} sm={12} style={{ display: estadoModal === 2 ? 'none' : 'inline' }}>
                      <SelecionarArquivo
                        setChave={setChave}
                        identificador={true}
                        label=""
                      />
                    </Col>

                    <Col xs={24} sm={12} style={{ display: estadoModal === 1 ? 'none' : 'inline' }}>
                      <Button
                        id="arquivo"
                        title="Arquivo"
                        shape="round"
                        icon={<EyeOutlined />}
                        htmlType="button"
                        onClick={() => {
                          if (form?.getFieldValue("idHabilitacao") && form?.getFieldValue("idHabilitacao") < 0) { // NOVO REGISTRO 
                            getDocPdf(form?.getFieldValue("chave"));
                          } else if (form?.getFieldValue("idHabilitacao") && form?.getFieldValue("idHabilitacao") > 0) { // REGISTRO JÁ SALVO NA BASE
                            getDocPdf(form?.getFieldValue("idDocumento"));
                          }
                        }}
                      />
                    </Col>
                  </Row>
                </>
              </Card>

              <Tabs>
                <Tabs.TabPane tab="Documentação da Entidade" key="item-1">
                  <>
                    <DirigenteHabilitacaoDocumentoEntidade
                      form={form}
                      documentos={dirigenteHabilitacaoDocumentoEntidade}
                      setDocumentos={setDirigenteHabilitacaoDocumentoEntidade}
                      ctrlDoc={ctrlDocEfpc}
                      manter={manter}
                    />
                  </>
                </Tabs.TabPane>

                <Tabs.TabPane tab="Documentação de Análise" key="item-2">
                  <>
                    <DirigenteHabilitacaoDocumentoAnalise
                      form={form}
                      documentos={dirigenteHabilitacaoDocumentoAnalise}
                      setDocumentos={setDirigenteHabilitacaoDocumentoAnalise}
                      ctrlDoc={ctrlDocAnalise}
                      manter={manter}
                    />
                  </>
                </Tabs.TabPane>

                <Tabs.TabPane tab="Observações" key="item-3">
                  <Row>
                    <Col xs={24} sm={24}>
                      <Form.Item label='Observação'
                        labelCol={{ span: 24 }}
                        name='teObservacao'
                        colon={false}
                      >
                        <TextArea rows={4}
                          placeholder='Observação'
                          disabled={estadoModal === 2}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Tabs.TabPane>

              </Tabs>

            </>
          </Spin>
        </Modal>
      </>

      <Row style={{ display: exibirDirigenteHabilitacaoCadastrada }}>
        <Col
          xs={24}
          xl={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small" columns={columns} dataSource={mandatoHabilitacao} pagination={false} />
        </Col>
      </Row>

    </>
  )
};

export default DirigenteHabilitacao;